import React, { useEffect } from 'react'

import { RouterProvider } from 'react-router-dom'
import { withAuthorizationContext } from 'contexts/authorization'
import { withClientContext } from 'contexts/client'
import { withGlobalContext } from 'contexts/global'

import { enableDarkMode, initTheme, Theme } from '@interco/inter-ui'

import { router } from '../routes'
import { PageStyle } from './styles'

const App = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const darkmode = urlParams.get('darkMode')

    if (darkmode === 'true') {
      enableDarkMode()
    }

    initTheme(Theme.PF)
  }, [])

  return (
    <PageStyle>
      <RouterProvider router={router} />
    </PageStyle>
  )
}

export default withGlobalContext(withAuthorizationContext(withClientContext(App)))
